const IDLE_TIMEOUT_MS = 2000;
const FALLBACK_DELAY_MS = 300;

/** Runs `callback` once the browser is idle; returns a cancel function. */
export function runWhenIdle(callback: () => void): () => void {
  if (typeof window.requestIdleCallback === 'function') {
    const handle = window.requestIdleCallback(callback, { timeout: IDLE_TIMEOUT_MS });
    return () => window.cancelIdleCallback(handle);
  }
  // Safari has no requestIdleCallback.
  const handle = window.setTimeout(callback, FALLBACK_DELAY_MS);
  return () => window.clearTimeout(handle);
}
